import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useEmpresa } from "@/hooks/empresas";
import { AvaliacaoProvider } from "@/context/avaliacoes/avaliacao";
import { EmpresaProvider } from "@/context/empresas/empresa";
import { FranqueadosProvider } from "@/context/franqueados";
import { Page, DashboardContainer } from "@/components/Grid";
import { Navbar } from "@/components/Blocks";
import { FullPageLoader } from "@/components/Common";
import { Sidebar, SubMenu, Sobre, TCEs, Boletos } from "@/components/Empresa";
import ListarAvaliacoes from "@/components/Empresa/Avaliacoes/ListarAvaliacoes";

import {
  PaineisContainer,
  PainelPrincipal,
  Content,
  MenuInterno,
} from "./styles";

function _Perfil({ history }) {
  const { data: user } = useSelector(state => state.auth);
  const { fetchEmpresa, empresa } = useEmpresa();
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    fetchEmpresa(user.empresa.id);
    handleGoToTab();
  }, []);

  function handleGoToTab() {
    const { location } = history;
    if (location.hasOwnProperty("state") && location.state !== undefined) {
      const { state } = location;
      if (state.hasOwnProperty("tab")) {
        const { tab } = history.location.state;
        if (tab === "TCEs") setTabIndex(1);
      }
    }
  }

  return (
    <Page>
      <Navbar type="interna" />
      {!empresa && <FullPageLoader />}
      {empresa && (
        <DashboardContainer>
          <PaineisContainer>
            <Sidebar />
            <Content>
              <MenuInterno>
                <SubMenu type="empresa" />
              </MenuInterno>
              <PainelPrincipal>
                <h1>Empresa</h1>
                <Tabs
                  forceRenderTabPanel={true}
                  selectedIndex={tabIndex}
                  onSelect={index => setTabIndex(index)}
                >
                  <TabList>
                    <Tab>Sobre a empresa</Tab>
                    <Tab>Contratos</Tab>
                    <Tab>Avaliações</Tab>
                    <Tab>Boletos</Tab>
                  </TabList>
                  <TabPanel>
                    <Sobre />
                  </TabPanel>
                  <TabPanel>
                    <TCEs />
                  </TabPanel>
                  <TabPanel>
                    <ListarAvaliacoes />
                  </TabPanel>
                  <TabPanel>
                    <Boletos />
                  </TabPanel>
                  {/* <TabPanel>Conta</TabPanel> */}
                </Tabs>
              </PainelPrincipal>
            </Content>
          </PaineisContainer>
        </DashboardContainer>
      )}
    </Page>
  );
}

export default function Perfil(props) {
  return (
    <EmpresaProvider>
      <FranqueadosProvider>
        <AvaliacaoProvider>
          <_Perfil {...props} />
        </AvaliacaoProvider>
      </FranqueadosProvider>
    </EmpresaProvider>
  );
}
